//'use strict';

angular.module('TurneroApp').component('coCancelarTurno', {
    controller: [
        '$stateParams',
        '$http',
        'turnosService',
        'portal',
        function ($stateParams, $http, turnosService, portal) {
            var ctrl = this;
            ctrl.hashTurno = $stateParams.idTurno;
            ctrl.idTurno = '0';
            ctrl.$onInit = function () {
                ctrl.GetIdFromBase64(ctrl.hashTurno);
            };

            ctrl.loading = false;
            ctrl.cancelado = false;
            ctrl.cancelFailed = false;

            ctrl.onClickAceptar = function (hashTurno) {
                if (hashTurno) {
                    ctrl.encryptedData = hashTurno;
                    ctrl.loading = true;
                    turnosService.CancelarTurnoPorUuid({ 'hash_turno': ctrl.encryptedData }, function () {
                        ctrl.cancelado = true;
                        ctrl.redirectVeDi();
                    }, function (error) {
                        ctrl.cancelFailed = true;
                        var res = error.data ? (error.data.ExceptionMessage ? error.data.ExceptionMessage.split("-") : (error.data.Message ? error.data.Message.split("-") : error.data.split("-"))) : (error.message ? error.message.split("-") : (typeof error === 'string' ? error.split("-") : error.statusText));
                                              
                        if (res[1].trim() == "01" || res[1].trim() ==  "0"){
                            ctrl.errorMessage = "Error no esperado";
                        } else {
                            ctrl.errorMessage = res[1].trim()
                        }
                        ctrl.redirectVeDi();
                    });
                } else {
                    ctrl.loading = false;
                }
            };

            ctrl.cancelar = function () {
                ctrl.loading = true;
                ctrl.redirectVeDi();
            };

            ctrl.redirectVeDi = function () {
                setTimeout(() => {
                    window.open("https://vedi.cordoba.gob.ar", "_self");
                    window.close;
                }, 3000);
            }

            ctrl.home = function () {
                window.open("https://vedi.cordoba.gob.ar", "_self");
            };

            // GetIdFromBase64 returns an original id_turno from a base64 according to the constant length of GUID data (guid_length) 
            ctrl.GetIdFromBase64 = function (base64) {
                const guid_length = 36;
                var decodedData = window.atob(base64);
                var id_turno = decodedData.substring(0, (decodedData.length - guid_length));
                ctrl.idTurno = id_turno;
            };
        }
    ],
    template: require('./cancelarTurno.html')
})



// WEBPACK FOOTER //
// ./app/components/cancelarTurno/cancelarTurnoComponent.js